<div class="copy-tree">
    <div
        style="visibility: hidden; position: fixed"
        [style.left]="contextMenuPosition.x"
        [style.top]="contextMenuPosition.y"
        [matMenuTriggerFor]="contextMenu"
    ></div>
    <mat-menu #contextMenu="matMenu">
        <button
            type="button"
            mat-menu-item
            (click)="onCopySection()"
        >
            <mat-icon>content_copy</mat-icon>
            Zaznacz sekcję
        </button>
        <button
            type="button"
            mat-menu-item
            (click)="onDeselectSection()"
            [disabled]="!clickedElements.selected"
        >
            <mat-icon>deselect</mat-icon>
            Odznacz sekcję
        </button>
    </mat-menu>
    <h3 class="copy-tree__title {{ side() }}">{{ title() }}</h3>
    @if (publication(); as pub) {
        <div class="copy-tree__heading">
            <h3>{{ pub.name }}</h3>
            <span>Wybrano: {{ clickedElements.selected }}</span>
        </div>
        <mat-tree
            #tree
            [dataSource]="pub.sections || []"
            [childrenAccessor]="childrenAccessor"
            class="tree-list"
        >
            <mat-nested-tree-node *matTreeNodeDef="let node">
                <a
                    mat-menu-item
                    class="leaf-node tree-link-item"
                    [class.active]="clickedElements.get(getNodeKey(node))"
                    (click)="onNodeClick($event, node)"
                    (contextmenu)="onNodeRightClick($event, node)"
                    (keydown)="onNodeKeydown($event)"
                    tabindex="0"
                >
                    {{ node.name }}
                </a>
            </mat-nested-tree-node>
            <mat-nested-tree-node
                *matTreeNodeDef="let node; when: hasChild"
                matTreeNodeToggle
                [cdkTreeNodeTypeaheadLabel]="node.name"
            >
                <div class="mat-tree-node">
                    <button
                        mat-icon-button
                        matTreeNodeToggle
                        [attr.aria-label]="'Toggle ' + node.name"
                        class="tree-btn"
                    >
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{
                                tree.isExpanded(node)
                                    ? "expand_more"
                                    : "chevron_right"
                            }}
                        </mat-icon>
                    </button>
                    <a
                        mat-menu-item
                        (click)="onNodeClick($event, node)"
                        (dblclick)="onNodeDBLClick($event, node)"
                        (contextmenu)="onNodeRightClick($event, node)"
                        [class.active]="clickedElements.get(getNodeKey(node))"
                        (keydown)="onNodeKeydown($event)"
                        tabindex="0"
                        class="tree-link-item"
                    >
                        {{ node.name | decodeHTMLString }}
                    </a>
                </div>
                <div
                    [class.tree-list-invisible]="!tree.isExpanded(node)"
                    role="group"
                >
                    <ng-container matTreeNodeOutlet></ng-container>
                </div>
            </mat-nested-tree-node>
        </mat-tree>
    } @else {
        <p>No data</p>
    }
</div>
